import React from 'react';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { handleFormErrors } from '../../common/errorHelpers';
import { DetailsPageHeader } from '../../components/DetailsPageHeader';
import { pathToUrl } from '../../utils/router';
import { PageRoutesEnum } from '../../utils/routes';

import { ClientDataForm } from './ClientDataForm';
import { useAddClient } from './useAddClient';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 20px;
`;

export const AddClientPage: React.FC = () => {
  const [form] = Form.useForm();
  const addClient = useAddClient();
  const navigate = useNavigate();

  const handleSave = async () => {
    const dataValues = form.getFieldsValue();
    const { data } = await addClient.mutateAsync(
      { data: dataValues },
      {
        onError: (error) => {
          handleFormErrors({ error, form });
        },
      }
    );
    navigate(pathToUrl(PageRoutesEnum.clientEdit, { id: data.uuid }));
  };

  const handleCancel = () => navigate(-1);

  return (
    <MainContainer>
      <DetailsPageHeader title="Add client" onSave={handleSave} onCancel={handleCancel} />
      <ClientDataForm form={form} />
    </MainContainer>
  );
};
